/**
 * Style tokens for consistent color usage across the application
 */

export const COLOR_TOKENS = {
  addFollowUpAgentIcon: '#647C69',
} as const
